$(document).ready(function() {

  setTimeout(function() {
    $('#argentina-states + span').css('display', 'none');
  }, 200);

  var defaultstate = $('#brasil-states').val();
  if (defaultstate) {
    $('.contact__card[state-name="' + defaultstate + '"]').show();  
  }
  $('#brasil-states, #argentina-states').on('change', function() {
    let selected = $(this).val();
    $('#states-select option[value!=buenos-aires]').hide();
    if (selected === 'estados_argentina') {
      $('g path').removeClass('active');
      $('#buenos-aires').addClass('active');
    }
    $('g path').removeClass('active');
    $('#' + selected + ' path').addClass('active');
    $('.contact__card').hide();
    $('.contact__card[state-name="' + selected + '"]').show();
  });

  $('#country-select').on('change', function() {
    let country = $(this).val();
    $('.units-maps__map').removeClass('active');
    $('#' + country).addClass('active');
    if (country === 'estados_argentina') {
      $('#brasil-states + span').css('display', 'none');
      $('#argentina-states + span').css('display', 'block');
      $('g path').removeClass('active');
      $('#buenos-aires').addClass('active');
      var argentinastate = $('#argentina-states').val();
      if (argentinastate) {
        $('.contact__card').hide();
        $('.contact__card[state-name="' + argentinastate + '"]').show();  
      }
    }
    if (country === 'estados') {
      $('#brasil-states + span').css('display', 'block');
      $('#argentina-states + span').css('display', 'none');
      var brasilstate = $('#brasil-states').val();
      if (brasilstate) {
        $('.contact__card').hide();
        $('.contact__card[state-name="' + brasilstate + '"]').show();  
      }
    }
  });

  $('#worldmap .units-subtitle__item').each(function() {
    let companyName = $(this).text().trim();
    let slug = companyName.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    let color = $(this).attr('data-color');
    $('path.' + slug).css('fill', color);
  });

});